import React from "react";
import PropTypes from "prop-types";

const Skeleton = ({ className = "", width, height, style }) => {
  return (
    <div
      className={`animate-pulse bg-surface-2 rounded ${className}`}
      style={{
        width: width,
        height: height,
        ...style,
      }}
    />
  );
};

Skeleton.propTypes = {
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

export default Skeleton;
